import React from "react";
import ReactDOM from "react-dom";
import { Catalog, pageLoader } from "catalog";
import './styles.css';

const antikorTheme = {
  fontFamily: '"Saira", sans-serif',
  fontHeading: '"Special Gothic Expanded One", sans-serif',
  fontMono: '"Space Mono", monospace',

  background: '#FFFFFF',
  textColor: '#1E1E1E',
  brandColor: '#1E1E1E',
  pageHeadingBackground: '#1E1E1E',
  pageHeadingTextColor: '#E5E5E5',
  pageHeadingHeight: '350',
  navBarBackground: '#E5E5E5',
  navBarTextColor: '#1E1E1E',
  sidebarColor: '#FFFFFF',
  sidebarColorLine: '#235187',
  sidebarColorText: '#3C74C6',
  sidebarColorTextActive: '#235187',
  linkColor: '#3C74C6',
  msRatio: '1.3'
};

const pages = [
  {
    path: "/",
    title: "Úvod",
    content: pageLoader(() => import("./home.md"))
  },
  {
    title: 'Základní informace',
    pages: [
      {
        path: '/brand/basics',
        title: 'O značce',
        content: pageLoader(() => import('./content/brand/basics.md'))
      }
    ]
  },
  {
    title: 'Typografie',
    pages: [
      {
        path: '/typography/headings',
        title: 'Nadpisy a podnadpisy',
        content: pageLoader(() => import('./content/typo/headings.md'))
      },
      {
        path: '/typography/paragaphs',
        title: 'Odstavce a souvislý text',
        content: pageLoader(() => import('./content/typo/paragraphs.md'))
      }
    ]
  },
  {
    title: 'Barevnost',
    pages: [
      {
        path: '/color/colors',
        title: 'Primární a sekundární barvy',
        content: pageLoader(() => import('./content/color/colors.md'))
      },
      {
        path: '/color/palette',
        title: 'Barevná paleta',
        content: pageLoader(() => import('./content/color/palette.md'))
      }
    ]
  },
  {
    title: 'Logotyp',
    pages: [
      {
        path: '/brand/symbol',
        title: 'Symbol',
        content: pageLoader(() => import('./content/logo/symbol.md'))
      },
      {
        path: '/brand/logo',
        title: 'Varianty loga',
        content: pageLoader(() => import('./content/logo/variants.md'))
      },
      {
        path: '/brand/safe',
        title: 'Bezpečná zóna',
        content: pageLoader(() => import('./content/logo/safe.md'))
      }
    ]
  }
];


ReactDOM.render(
  <Catalog title="Digitální manuál ANTIKOR" logoSrc="/logo.svg" pages={pages} theme={antikorTheme} />,
  document.getElementById("catalog")
);



// WEBPACK FOOTER //
// ./catalog/index.js